import React, { useEffect, useState } from "react";
import "./login.css";
import { Container, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { loginUserAction } from "../../../redux/actions/AuthAction";
// import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import notify from "../../Notifcation";
import { Fade, Zoom } from "react-awesome-reveal";
import {
  getLoggedUserAction,
  loginUserAction,
} from "../../../redux/actions/AuthAction";
import InstallPWAButton from "../../InstallPWAButton/InstallPWAButton";
const Login = () => {
  const dispatch = useDispatch();
  const [Phone, setPhone] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [Password, setPassword] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const navegate = useNavigate();
  const validationValues = () => {
    if (Phone === "" || passwordInput === "") {
      notify("من فضلك ادخل البيانات ", "error");
      return;
    }
  };

  const onPasswordChange = (e) => {
    setPasswordInput(e.target.value);
  };
  const toggle = () => {
    if (Password === "password") {
      setPassword("text");
      return;
    }
    setPassword("password");
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    const error = validationValues();
    if (error) return;
    setIsPress(true);
    setLoading(true);
    await dispatch(
      loginUserAction({
        phoneNumber: Phone,
        password: passwordInput,
      })
    );
    setLoading(false);
    setIsPress(false);
  };

  const res = useSelector((state) => state.authReducer.loginUser);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.token) {
            localStorage.setItem("tokenhr", res.data.token);
            dispatch(getLoggedUserAction());
            notify("تم تسجيل الدخول بنجاح", "success");
            setTimeout(() => {
              if (res.data.roleName === "admin") {
                window.location.href = "/admin";
              } else if (res.data.roleName === "Responsible"||res.data.roleName === "Manger") {
                navegate("/user/mainuserpage");
              } else if (res.data.roleName === "Employee") {
                navegate("/user/hodoremp");
              }
            }, 2000);
          } else if (
            res.data &&
            res.data.responseMessage === "PhoneNumber or Password is incorrect!"
          ) {
            notify("خطأ في كلمة السر او رقم الهاتف", "error");
          }
          if (
            res.data.responseMessage ===
            "Your account is not active please call the admin"
          ) {
            notify("هذا الأكونت غير مفعل", "error");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (
            res.data &&
            res.data.responseMessage === "PhoneNumber or Password is incorrect!"
          ) {
            notify("خطأ في كلمة السر او رقم الهاتف", "error");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const resCurrnt = useSelector((state) => state.authReducer.currentUser);

  useEffect(() => {
    // if (loading === false) {
    if (localStorage.getItem("tokenhr") !== null) {
      localStorage.setItem("userhr", JSON.stringify(resCurrnt));
      if (resCurrnt) {
        if (resCurrnt.roleName === "Responsible"||  resCurrnt.roleName === "Manger") {
          setTimeout(() => {
            window.location.href = "/user/mainuserpage";
          }, 1500);
        }
        if (resCurrnt.roleName === "Employee") {
          setTimeout(() => {
            window.location.href = "/user/hodoremp";
          }, 1500);
        }
        if (resCurrnt.roleName === "Admin") {
          setTimeout(() => {
            window.location.href = "/admin";
          }, 1500);
        }
        if (resCurrnt.roleName === "Editor") {
          setTimeout(() => {
            window.location.href = "/editor";
          }, 1500);
        }
      }
    }
    // }
  }, [resCurrnt]);

  // useEffect(() => {
  //   if (loading === false) {
  //     if (res) {
  //       if (res.data.token) {
  //         localStorage.setItem("tokenhr", res.data.token);
  //         localStorage.setItem("userhr", JSON.stringify(res.data));
  //         notify("تم تسجيل الدخول بنجاح", "success");
  //         // setTimeout(() => {
  //         //   window.location.href = "/";
  //         // }, 1500);
  //       } else {
  //         localStorage.removeItem("tokenhr");
  //         localStorage.removeItem("userhr");
  //       }

  //       if (
  //         res.data.responseMessage === "PhoneNumber or Password is incorrect!"
  //       ) {
  //         localStorage.removeItem("tokenhr");
  //         localStorage.removeItem("userhr");
  //         notify("كلمة السر او رقم الهاتف خطأ", "error");
  //       }

  //       setLoading(true);
  //     } else notify("كلمة السر او رقم الهاتف خطأ", "error");
  //   }
  // }, [loading]);
  // useEffect(() => {
  //   if (loading === false) {
  //     if (localStorage.getItem("tokenhr") !== null) {
  //       const dat = JSON.parse(
  //         atob(localStorage.getItem("tokenhr").split(".")[1])
  //       );

  //       if (
  //         dat[
  //           "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
  //         ] === "User"
  //       ) {
  //         setTimeout(() => {
  //           window.location.href = "/user/main";
  //         }, 1500);
  //       } else {
  //         setTimeout(() => {
  //           window.location.href = "/admin";
  //         }, 1500);
  //       }
  //     }
  //   }
  // }, [loading]);
  return (
    <div className="login">
      <Container>
        <div id="bar-progress" className="mt-5 mt-lg-0">
          <div className="step step-active">
            <h5 style={{ border: "3px solid blue" }}>تجربة مجانية</h5>
          </div>
          <div className="seperator"></div>
          <div className="step ">
            <h5 style={{ border: "3px solid yellow" }}>250 جنية شهرياً</h5>
          </div>
          <div className="seperator"></div>
          <div className="step">
            <h5 style={{ border: "3px solid orange" }}>2500 جنية سنوياً</h5>
          </div>
        </div>
        <InstallPWAButton />
        <div className="main-log">
          <div className="content-main">
            <Zoom triggerOnce="false">
              <h2>"تطبيق أعمال الموارد البشرية"</h2>
              <h2>" الموظفين والمرتبات والحضور والانصراف"</h2>
              <h3>
                نظام مرتبات وحضور وانصراف أونلاين ذكي وبسيط
                <i className="fa-solid fa-check"></i>
              </h3>
            </Zoom>
            <Fade direction="right" triggerOnce="false">
              {" "}
              <p>
                توفير الجهد والوقت والتكلفة تخلص من تعقيدات الأجهزة وتكاليف
                الصيانة والتركيب وضياع الوقت في إدارة الموظفين والمرتبات والحضور
                والانصراف لموظفي الشركات المتوسطة والصغيرة ومتناهية الصغر
                والمكاتب والمؤسسات ذات العمالة المحدودة.
              </p>
            </Fade>

            <Fade direction="right" triggerOnce="false">
              <ul>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> "تطبيق أعمال
                  الموارد البشرية" يوفر طريقة سهلة ومنضبطة للتعرف على هوية
                  الموظفين. إثبات موقع الموظف يوفر تطبيق أعمال أحدث التقنيات
                  لإثبات مواقع الموظفين بدقة عالية بواسطة تقنية تحديد الموقع
                  الجغرافي GPS التي تناسب أماكن العمل المفتوحة والواسعة.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> "تطبيق أعمال
                  الموارد البشرية" إدارة الموظفين ومواعيد العمل وإمكانية إضافة
                  مواعيد عمل متعددة تتناسب مع طبيعة عمل موظفيك، بالإضافة الى
                  سهولة تسجيل وإدارة الموظفين . يوفر لك إمكانية إثبات تواجد
                  الموظف خلال فترات العمل إذا كان لدى فريقك خيار العمل عن بعد أو
                  العمل خارج موقع الشركة، وبذلك ضمان التزام الموظفين،
                  وعدم عرقلة العمل.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" يوفر لك تقارير لحظية ومتنوعة
                  وتقارير بيانات الموظفين والمرتبات والحضور والانصراف يومية
                  وشهرية ولفترات معينة توضح كافة تفاصيل حضور وانصراف الموظفين
                  وساعات عملهم، أسلوب حديث وتقنية متطورة وتجربة ثرية
                  "معاً لمستقبل عصري"
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" ممتاز وسهل الاستخدام لموظفي
                  الشركة والإدارة مراجعة بيانات المرتبات وحضور وانصراف الموظفين
                  وتصحيح أخطاء الإدخال وفقا للصلاحيات المخولة للمستخدم إمكانية
                  تسجيل الإجازات الجماعية والإجازات الخاصة مع إمكانية تعلية رصيد
                  الإجازات في أي وقت تسجيل المأموريات والأذون الخاصة، مع احتساب
                  الحضور والإنصراف يتم التفاعل مع نتائج قيم الأجور والمرتبات و
                  الاستحقاقات والاستقطاعات
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" افضل الحلول لادارة الوقت
                  والمرتبات والأجور في تطوير المؤسسات يبدأ من كوادر العمل التي
                  تدير تنفيذ مهام العمل اليومية مع مميزات التطبيق لا تضيع الكثير
                  من الوقت الثمين في متابعة شؤون العاملين بعد اليوم.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  "تطبيق أعمال الموارد البشرية" مرتبات و حضور وانصراف الموظفين
                  يوفر وقتك ويوفر لك ما تحتاجه لإدارة موارد بشرية ناجحة. المرونة
                  في تحديد مواعيد العمل علي جميع مستويات الهيكل الوظيفي بطريقة
                  تتيح تحديد مواعيد العمل اليومية للحضور والانصراف وأوقات الراحة
                  وفترات إحتساب الأوقات الإضافية والأجازات الرسمية مع تحديد
                  فترات السماح بعد موعد الحضور قبل موعد الانصراف
                </li>
              </ul>
            </Fade>
          </div>
          <div className="login-container">
            <h2>تسجيل الدخول</h2>
            <div className="login">
              <TextField
                focused
                label="رقم الهاتف"
                variant="outlined"
                type="number"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <p id="user"></p>
              <TextField
                focused
                label="كلمة المرور"
                variant="outlined"
                // value={Password}
                // type="password"
                // onChange={(e) => setPassword(e.target.value)}
                type={Password}
                onChange={onPasswordChange}
                value={passwordInput}
                name="password"
                className="form-control"
              />
              <button className="btn btn-primary e" onClick={toggle}>
                {Password === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
              <p id="password"></p>

              <button style={{ height: "52px" }} onClick={handlesubmit}>
                {isPress === true && loading === true ? (
                  <Spinner animation="border" role="status"></Spinner>
                ) : (
                  "تسجيل الدخول"
                )}
              </button>

              <div className="social">
                <a href="https://www.facebook.com/hr/">
                  <i className="fa-brands fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/watch?v=YIQIJV6U6Ms&list=PL-6EWK16rlYQp6n7mTwJVgQILV_lZ_daq">
                  <i
                    style={{ color: "#fff" }}
                    className="fa fa-brands fa-youtube"></i>
                </a>
              </div>
              <Link to="/" style={{ color: "blue" }}>
                انشاء حساب جديد
              </Link>
              <Link to="/forget" style={{ color: "red" }}>
                نسيت كلمة السر ؟
              </Link>
            </div>
            <h5 className="text-center wtsus">
              <a
                style={{ color: "#fff !important" }}
                href="https://wa.me/+201001122424">
                {" "}
                تواصل معنا واتساب
              </a>
              <b>
                {" "}
                <i
                  className="fa-brands fa-whatsapp"
                  style={{ color: "#fff" }}></i>
              </b>
            </h5>
          </div>
        </div>
      </Container>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Login;
